import { render, staticRenderFns } from "./TabelaPercentual.vue?vue&type=template&id=436bcb09&scoped=true"
import script from "./TabelaPercentual.vue?vue&type=script&lang=js"
export * from "./TabelaPercentual.vue?vue&type=script&lang=js"
import style0 from "../../styles.scss?vue&type=style&index=0&id=436bcb09&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436bcb09",
  null
  
)

export default component.exports